import { useQuery } from "@tanstack/react-query";
import { opsFetch } from "./client.js";

export type OpsRole = "admin" | "support" | "analyst";

export interface OpsMe {
  email: string;
  givenName?: string;
  roles: OpsRole[];
}

/** The signed-in staffer's identity + role groups (GET /ops/me). */
export function useOpsMe(enabled = true) {
  return useQuery<OpsMe>({
    queryKey: ["ops", "me"],
    enabled,
    retry: 1,
    queryFn: () => opsFetch<OpsMe>("/ops/me"),
  });
}
